import getOffsetTop from '../../utils/getOffsetTop';

// let DEBUG_ID = 0;

export default function(elementWrap, browser, elementToPush, elementToFade, elementToRespect) {
	//event.scrollY
	elementWrap = (typeof elementWrap === 'function') ? elementWrap() : elementWrap;
	elementToPush = (typeof elementToPush === 'function') ? elementToPush() : elementToPush;
	elementToFade = (typeof elementToFade === 'function') ? elementToFade() : elementToFade;
	elementToRespect = (typeof elementToRespect === 'function') ? elementToRespect() : elementToRespect;
	// let _DEBUG_ID = DEBUG_ID++;

	let tryScroll = (event) => {
		//return false;
		// console.log(`[ID:${_DEBUG_ID}] tryScroll`);
		// let perf = performance.now() / 1000;
		// console.log(`[ID:${_DEBUG_ID}] START: ${perf}`);
		if (event && event.deltaY === 0) {
			return false;
		}

		event = event || { scrollY: window.scrollY };

		let splitter = 310;

		if (browser.window.width < 1200) {
			splitter = 150;
		}

		if (browser.window.width < 720) {
			splitter = 100;
		}

		let trigger = getOffsetTop(elementWrap) - 100;
		let ready = (event.scrollY >= trigger && event.scrollY < trigger + browser.window.height);
		let top = 0;
		let opacity = 1;
		let denominator = splitter;
		if (elementToRespect.offsetHeight + 50 > splitter) {
			denominator = elementToPush.offsetHeight - elementToRespect.offsetHeight - 50;
		} else {
			denominator = elementToPush.offsetHeight - splitter;
		}

		if (ready) {
			top = event.scrollY - trigger;
			if (top < 0) {
				top = 0;
			} else if (top < denominator) {
				top = top;
			} else {
				top = denominator;
			}

			opacity -= top / denominator;

			top += 'px';
			top = 'translatey(' + top + ')';
			elementToPush.style.transform = top;
			elementToPush.style.WebkitTransform = top;
			elementToPush.style.MozTransform = top;
			elementToFade.style.opacity = opacity;


			// console.log('RLY');
			// elementWrap.className += ' active132';
			// browser.scroll.deregister(tryScroll);
		}

		// let newPerf = (performance.now() / 1000);
		// console.log(`[ID:${_DEBUG_ID}] END: ${newPerf} - DIFF: ${newPerf - perf}`);

		return ready;
	};

	return tryScroll;
};


/** WEBPACK FOOTER **
 ** ./frontend/components/timeline/introActivate.js
 **/